import Icon from '@Shared/Icon';
import { ISearchResult } from '@src/interfaces';
import React from 'react';
import { Badge, ListGroupItem } from 'react-bootstrap';

interface Props {
  result: ISearchResult
}

const SearchResult: React.FC<Props> = (props) => {

  const getIcon = () => {
    let icon = '';
    switch (props.result.meta.real_type) {
      case 'invoice':
        icon = 'file-alt';
        break;
      case 'si':
        icon = 'wrench fas';
        break;
      case 'service':
        icon = 'power-off fas';
        break;
      case 'wo':
        icon = 'gift fas';
        break;
      case 'user':
        icon = 'user fas';
        break;
      case 'account':
      case 'subaccount':
        icon = 'book fas';
        break;
      case 'org':
        icon = 'home fas';
        break;
      case 'service_vendor':
      case 'vendor':
        icon = 'truck fas';
        break;
      case 'page':
        icon = 'file fas';
        break;
      case 'situation':
        icon = 'comment fas';
        break;
      case 'order_batch':
        icon = 'list fas';
        break;
    }
    return icon;
  }

  const getStatus = () => {
    let status = 'success';
    switch (props.result.meta.polarity) {
      case '0':
        status = 'warning';
        break;
      case '-1':
        status = 'danger';
        break;
    }
    return status;
  }

  return (
    <ListGroupItem
      style={{
        paddingLeft: 44, position: 'relative', overflow: 'hidden',
        paddingRight: '15px'
      }}
      action
      href={props.result.meta.path}
      target='_blank'
    >
      <Icon name={getIcon()} className='list-icon' style={{
        position: 'absolute',
        left: 12,
        top: 16,
        fontSize: 20
      }} />
      <Badge bg={getStatus() as 'warning'} style={{ float: 'right', lineHeight: '16px' }}>
        {props.result.meta.status}
      </Badge>
      {props.result.title}
    </ListGroupItem>
  );
}

export default SearchResult;